import { Job } from "types/entities/Jobs";

export const getSortedJobs = (jobList: Job[]): Job[] => {
  if (!jobList) return [];
  return [...jobList].sort((a, b) => {
    return new Date(a.created_dts).getTime() - new Date(b.created_dts).getTime();
  });
}
